import React, { useState } from "react";
import supabase from "../services/supabase";
import "../App.css";
import logo from "./IPTalonsLogo.png";

const Login = () => {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [isResetMode, setIsResetMode] = useState(false);
  const [resetStatus, setResetStatus] = useState("");

  const handleLogin = async () => {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: loginEmail,
        password: loginPassword,
      });
      
      if (error) throw error;

      // Explicitly store the session
      if (data.session) {
        await supabase.auth.setSession(data.session);
      }
    } catch (error) {
      alert('Error logging in: ' + error.message);
    }
  };

  const handlePasswordReset = async () => {
    const { error } = await supabase.auth.resetPasswordForEmail(loginEmail, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    
    if (error) {
      setResetStatus('Error sending reset email: ' + error.message);
    } else {
      setResetStatus('Password reset email sent! Please check your inbox.');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <div className="login-logo-container">
          <img src={logo} alt="Sitruna Logo" className="login-logo" />
        </div>
        <h2 className="login-title">Sign in to your account</h2>
        <div className="login-form-container">
          <div className="login-form-card">
            <input
              id="email"
              type="email"
              className="login-input"
              placeholder="Email address"
              value={loginEmail}
              onChange={(e) => setLoginEmail(e.target.value)}
            />
            {!isResetMode && (
              <input
                id="password"
                type="password"
                className="login-input"
                placeholder="Password"
                value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)}
              />
            )}
          </div>
          {!isResetMode ? (
            <>
              <button className="login-button" onClick={handleLogin}>
                Login
              </button>
              <button
                onClick={() => setIsResetMode(true)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#1C6941',
                  marginTop: '15px',
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
              >
                Forgot Password?
              </button>
            </>
          ) : (
            <>
              <button className="login-button" onClick={handlePasswordReset}>
                Send Reset Link
              </button>
              <button
                onClick={() => setIsResetMode(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#1C6941',
                  marginTop: '15px',
                  cursor: 'pointer'
                }}
              >
                Back to Login
              </button>
            </>
          )}
          {resetStatus && (
            <div style={{ marginTop: '15px', textAlign: 'center', color: resetStatus.includes('Error') ? 'red' : 'green' }}>
              {resetStatus}
            </div>
          )}
        </div>
      </div>
      <div className="login-footer">
        &copy; 2025 IPTalons, Inc. All rights reserved.
      </div>
    </div>
  );
};

export default Login;
